import { createIcon } from '@chakra-ui/react';

export const MbeClose = createIcon({
  displayName: 'MbeClose',
  viewBox: '0 0 32 32',
  path: (
    <>
      <defs>
        <path d="M0 0h28v28H0z" id="ydv34rv6ya" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          d="m16.91 16 4.597-4.597a.643.643 0 1 0-.91-.91L16 15.09l-4.597-4.597a.643.643 0 0 0-.91.91L15.09 16l-4.597 4.597a.644.644 0 0 0 .91.91L16 16.91l4.597 4.597a.641.641 0 0 0 .91 0 .643.643 0 0 0 0-.91L16.91 16z"
          fill="#E2001A"
        />
        <g transform="translate(2 2)">
          <mask fill="#fff" id="0jdwcos3db">
            <use xlinkHref="#ydv34rv6ya" />
          </mask>
          <path
            d="M14 .706C6.67.706.706 6.67.706 14S6.67 27.294 14 27.294 27.294 21.33 27.294 14 21.33.706 14 .706M14 28C6.28 28 0 21.72 0 14S6.28 0 14 0s14 6.28 14 14-6.28 14-14 14"
            fill="#E2001A"
            mask="url(#0jdwcos3db)"
          />
        </g>
      </g>
    </>
  ),
});
